import React, { useEffect, useState, useRef } from 'react'
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Container, Col, Row } from 'react-bootstrap'
import { Paper } from '@mui/material'

import DataTable from 'Shared/Components/DataTable'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import BackLinkButton from 'Shared/Components/BackLinkButton'
import CalanderView from './components/CalanderView'
import './components/styles.css'

const PermitToWorkTemplateDetail = () => {
  const { role, projectInfo, setPageLoading } = useOutletContext()
  
  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()
  const { template_id } = useParams()

  const [formTemplateDetail, setFormTemplateDetail] = useState({})
  const [formList, setFormList] = useState([])
  const [holiday, setHoliday] = useState({})
  const [authorizationPerson, setAuthorizationPerson] = useState([])

  const tableRef = useRef()
  
  useEffect(() => {
    const init = async () => {
      const getFormTemplateDetail = async () => {
        const body = await send({
          method: "GET",
          url: `${apiUrl}/permit_to_work/template_detail`,
          params: {
            "template_id": template_id
          },
          returnType: "json"
        })

        setFormTemplateDetail(body)
      }

      const getHoliday = async () => {
        const body = await send({
          method: "GET",
          url: `${apiUrl}/common/holiday`,
          params: {
            "template_id": template_id
          },
          returnType: "json"
        })

        setHoliday(body)
      }

      const getAuthorizationPerson = async () => {
        const body = await send({
          method: "GET",
          url: `${apiUrl}/permit_to_work/get_authorization_person`,
          params: {
            "template_id": template_id
          },
          returnType: "json"
        })
    
        setAuthorizationPerson(body)
      }

      setPageLoading(true)

      await Promise.all([
        getFormTemplateDetail(),
        getHoliday(),
        ["admin", "pm", "so"].includes(role) && getAuthorizationPerson()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  const handleChange = async (date) => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/permit_to_work/form_summary`,
      params: {
        "template_id": template_id,
        "year": date.get("year"),
        "month": date.get("month") + 1
      },
      returnType: "json"
    })

    setFormList(body)
  }

  return (
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", paddingLeft: 0, paddingRight: 0, display: "flex", flexFlow: "column" }}>
          <BackLinkButton />

          <div style={{ flexGrow: 1, overflow: "auto", margin: "10px", paddingLeft: "10px", paddingRight: "10px" }}>
            <div style={{ minWidth: "960px" }}>
              <div>
                {(formTemplateDetail["template_name"] !== 0) &&
                  <CalanderView formTemplateDetail={formTemplateDetail} formList={formList} holiday={holiday} handleChange={handleChange}/>
                }
              </div>

              {["admin", "pm", "so"].includes(role) && <>
                <hr />
              
                <div><u><b>Authorizated Person</b></u></div>

                <Paper elevation={0} sx={{ display: "flex", flexFlow: "column" }}>
                  <DataTable
                    data={authorizationPerson} count={null} ref={tableRef}
                    columns={{
                      "worker_name": { "label": t("general_workerName"), "sorting": false, "nowrap": true },
                    }}
                  />
                </Paper>
              </>}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default PermitToWorkTemplateDetail
